export const buildAgendasKpis = (stats, centreConfig) => {
  if (!stats) return null
  return {
    title: `Agendas: ${stats.doctorsWithWorkTimes + stats.machinesCount} / ${centreConfig.subscriptionAgendasQuantity || 0}`,
    items: [
      { label: 'Profesionales con agenda: ', value: stats.doctorsWithWorkTimes },
      { label: 'Agendas (nuevas de equipo): ', value: stats.machinesCount },
    ],
  }
}

export const buildTurnsKpis = (stats) => {
  if (!stats) return null
  return {
    title: `Turnos: ${stats.turnsCount}`,
    items: [
      { label: 'Online: ', value: stats.turnsCreatedByPatient },
      { label: 'Creados por centro: ', value: stats.turnsCreatedByCentre },
      { label: 'Creados por profesional: ', value: stats.turnsCreatedByDoctor },
      { label: 'Ausentes: ', value: stats.turnsAbsent },
    ],
  }
}

export const buildUsersKpis = (stats) => {
  if (!stats) return null
  return {
    title: `Usuarios`,
    items: [
      { label: 'Profesionales: ', value: stats.doctorsWithUser },
      { label: 'Asistentes: ', value: stats.secretarysCount },
      { label: 'Pacientes: ', value: stats.patientsCount },
    ],
  }
}

export const buildWappModuleKpis = (stats) => {
  if (!stats) return null
  return {
    title: `Módulo WhatsApp`,
    items: [{ label: 'Recordatorios enviados en el mes: ', value: stats.wappRemindersCount }],
  }
}

export const buildHCModuleKpis = (stats) => {
  if (!stats) return null
  return {
    title: `Módulo Historia Clínica`,
    items: [{ label: 'Fichas creadas en el mes: ', value: stats.HCsCount }],
  }
}

export const buildPrescriptionsModuleKpis = (stats) => {
  if (!stats) return null
  return {
    title: `Módulo recetas`,
    items: [{ label: 'Creadas en el mes: ', value: stats.prescriptionsCount }],
  }
}

export const buildCashBoxModuleKpis = (stats) => {
  if (!stats) return null
  return {
    title: `Módulo Caja`,
    items: [
      { label: 'Total ingresos caja: ', value: stats.cashboxItemsTotalIncome },
      { label: 'Total ingresos turnos: ', value: stats.turnsIncome },
      { label: 'Total egresos caja: ', value: stats.cashboxItemsTotalExpense },
      { label: 'Balance: ', value: stats.cashboxItemsTotal + stats.turnsIncome },
    ],
  }
}

export const buildPaymentMPModuleKpis = (stats) => {
  if (!stats) return null
  return {
    title: `Módulo pagos MP`,
    items: [
      { label: 'Cantidad de turnos: ', value: stats.turnsWithMPLinkPayment },
      { label: 'Ingresos en el mes: ', value: stats.turnsMPLinkIncome },
    ],
  }
}

export const buildModulesInUseKpis = (stats) => {
  if (!stats) return null
  return {
    title: `Módulos en uso`,
    items: [
      { label: 'Módulo agenda: ', value: stats.isAgendaModuleInUse ? 'Sí' : 'No' },
      { label: 'Módulo caja: ', value: stats.isCashboxModuleInUse ? 'Sí' : 'No' },
      { label: 'Módulo Mercado Pago: ', value: stats.isMPModuleInUse ? 'Sí' : 'No' },
      { label: 'Módulo recordatorios wapp: ', value: stats.isWappReminderModuleInUse ? 'Sí' : 'No' },
      { label: 'Módulo recetas: ', value: stats.isPrescriptionModuleInUse ? 'Sí' : 'No' },
      { label: 'Módulo historias clínicas: ', value: stats.isHCModuleInUse ? 'Sí' : 'No' },
    ],
  }
}
